<template>
<div class="fixedHeight">
    <div v-if="documents.length < 1">
        There are no documents currently uploaded.
    </div>
    <table v-else style="width: 100%">
        <tbody>
            <tr v-for="doc in documents" :key="doc.id">
                <td>
                    <a href="#" @click.prevent="goTo(doc)">
                        <i class="fa fa-download"></i>
                        {{doc.name}}
                    </a>
                </td>
                <td>
                    {{$formatters.date(doc.createdDate)}}
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            documents: [],
        }
    },
    computed: {
        title() { return "Participant CIP Uploads" },
        buttons() { return "Cancel" },
    },
    async created() {
        console.log("CipDocuments created item:", this.item);
        this.documents = await romeApi.get(`participant/${this.item.participantId}/file/cip`);
    },
    methods: {
        async goTo(row) {
            // console.log("CipDocuments goTo row:", row);
            if(row.cloud) window.open(row.link, '_blank');
            else await romeApi.download(row.link);
        },
    }
}
</script>
<style lang="scss" scoped>
    .fixedHeight{
        overflow-y: auto;
        max-height: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/action-items/types/CipDocuments.vue